import React from "react";

function chatfeed(props) {
  console.log(props);
  return (
    <div>
      <div className="holder">
        <h1>Public Group</h1>
      </div>
    </div>
  );
}

export default chatfeed;
